(function () {
  function initFaq(root) {
    root.querySelectorAll('.fab-faq__question').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.fab-faq__item');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  document.querySelectorAll('.fab-faq').forEach(initFaq);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.fab-faq');
    if (section) initFaq(section);
  });
})();
